import { render } from "./App.vue?vue&type=template&id=01c817fb"
const script = {}

import "./App.vue?vue&type=style&index=0&id=01c817fb&lang=css"

import exportComponent from "/Users/victorbello/Documents/Tizeti/Hotspot/eutelsat_branch/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__